"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var QuestionMark = function QuestionMark(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 30 30'
  }, props), /*#__PURE__*/_react["default"].createElement('g', {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(-886.000000, -27.000000)',
    fill: 'currentColor',
    fillRule: 'nonzero'
  }, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M900.799618,27.0013632 C892.515969,27.1122324 885.891137,33.9179684 886.001356,42.2018511 C886.112226,50.4821469 892.917385,57.1088618 901.200708,56.9986448 C909.482726,56.8871235 916.108863,50.0813875 915.998645,41.7981569 C915.887774,33.5172089 909.082289,26.8908201 900.799618,27.0013632 Z M900.75527,51.1304054 L900.672443,51.1291011 C899.396782,51.0912751 898.497427,50.151496 898.533623,48.8947614 C898.569167,47.6595485 899.490369,46.7628127 900.723965,46.7628127 L900.797988,46.764117 C902.109193,46.8029212 902.998439,47.7332439 902.961591,49.026174 C902.925069,50.2649738 902.018214,51.1304054 900.75527,51.1304054 Z M906.121071,40.4807704 C905.821069,40.9069645 905.16139,41.4362017 904.330188,42.0838081 L903.414855,42.7157623 C902.912351,43.106413 902.609088,43.4739117 902.495283,43.8355408 C902.405608,44.1202137 902.361586,44.1955395 902.35376,44.7746678 L902.352456,44.9217325 L898.85743,44.9217325 L898.867539,44.6259727 C898.910256,43.4103249 898.940256,42.6952189 899.444065,42.1043515 C900.234505,41.1763114 901.978105,40.0535981 902.052128,40.0059896 C902.301912,39.8178381 902.512566,39.6035997 902.669415,39.3746875 C903.036265,38.8689285 903.198658,38.4707778 903.198658,38.0794749 C903.198658,37.5365421 903.03757,37.03437 902.71898,36.5873064 C902.412782,36.155895 901.831039,35.9374175 900.989728,35.9374175 C900.155266,35.9374175 899.583957,36.2021991 899.242215,36.745458 C898.890691,37.3040429 898.712972,37.8906712 898.712972,38.4900169 L898.712972,38.639038 L895.109358,38.639038 L895.11588,38.4834951 C895.208816,36.2762206 895.996648,34.6868786 897.45655,33.7594907 C898.373839,33.1689494 899.515152,32.8696026 900.846901,32.8696026 C902.590175,32.8696026 904.061816,33.293188 905.220412,34.1286198 C906.394334,34.9751384 906.989773,36.2429599 906.989773,37.8968668 C906.989773,38.8219722 906.697597,39.6909907 906.121071,40.4807704 Z'
  }))));
};
var _default = QuestionMark;
exports["default"] = _default;